/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { 
  Box,
  Link,
  Container, 
  TextField, 
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';

import Logo from "../../assets/icons/lusidpay_logo.svg";
import LoadingButton from '../../components/buttons/Button';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

// import { 
//   LogIn 
// } from '../../redux/actions/authActions';

import { 
  CLEAR_COMPANY_ROLE_DASHBOARD, 
  LOG_OUT 
} from '../../redux/actionTypes';

import style from "../../global.scss";
import "./styles.scss";

const Data = {
  UserName: "",
  Password: ""
};

const AuthPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);

  const [passwordShow, setPasswordShow] = useState(false);

  useEffect(() => {
    try {
      dispatch({ type: CLEAR_COMPANY_ROLE_DASHBOARD });
    } catch (err){
      dispatch({ type: LOG_OUT });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    localStorage.setItem("navExpanded", true);

    if (formData.UserName === "jamesmiller.lusid@gmail.com" && 
      formData.Password === "@Aa12345678") {
        
        await setTimeout(async () => {
          await dispatch({ type: "LOG_IN", payload: {
        "access_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySWQiOiI1MzY4M2ZlMC02OWIzLTQ5NGUtYjlhZC0yYWJiMGNkNjNmNGUiLCJFbWFpbCI6ImphbWVzbWlsbGVyLmx1c2lkQGdtYWlsLmNvbSIsIkZpcnN0TmFtZSI6IkphbWVzIiwiTGFzdE5hbWUiOiJNaWxsZXIiLCJBdmF0YXIiOiIiLCJUZW5hbnQiOiIzOWM1NGJkZC03YTUyLTRmYTQtOWYzZi1jMGZjMTE3MDEwYTAiLCJpYXQiOjE3NzMxNDExNDUsImV4cCI6MTc3MzE0NDc0NX0.PK9OOH92SvpuMDLA3vE_6vvMhcA-gq5sYKIqV9mCqRH6PCJAHFwZ5KpOMCMW3ZdcdsdZatYxHFIZHLYFmL7HMDEWxUIMqFx5xNaGIYU_99cdnc0206jbfy3UIAIDeQlmCRgOFDvxGPMiTvAcxPRzDaDWc4uKOqZ7asUUJyUb5l8FXFw5Mof94YhQg63RG8F2JGNQr_KEmuPpfEo7PUef4yyQgfW9xQkD0myP3iuC0uPiZ4zwsbk4Bo7NVRdnfAo6YdPtjzyHncgGuuc-htBGbiQzRLlzlJmdJ-qfKFEqv3UFgO0lhMqPEDjLzhJrcfdhN5RtTXVJdPWnZnaRtZuP_A",
        "refresh_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySWQiOiI1MzY4M2ZlMC02OWIzLTQ5NGUtYjlhZC0yYWJiMGNkNjNmNGUiLCJFbWFpbCI6ImphbWVzbWlsbGVyLmx1c2lkQGdtYWlsLmNvbSIsIkZpcnN0TmFtZSI6IkphbWVzIiwiTGFzdE5hbWUiOiJNaWxsZXIiLCJBdmF0YXIiOiIiLCJUZW5hbnQiOiIzOWM1NGJkZC03YTUyLTRmYTQtOWYzZi1jMGZjMTE3MDEwYTAiLCJpYXQiOjE3NzMxNDExNDUsImV4cCI6MTc3Mzc0NTk0NX0.M2YEo69kiAMvoW4SHajWXd5G_SgS65nQmBW2kpOSU_lD0imLdFlGSMhM6Nmh8yseI7PrSIMw2EUVtLO7F4DQPvcO_x2OZBcwb3ewFHZzMDpMqwmtp0ROk6Gn9E1cDV7sQLj84xVp7yJHj2y-Syv24VZPFGqBxi1IbVsJQ4e-DbP4lquB3mws6b4tBMnVTz5NpWpUP03lVyA6V25vrjllrGafBuQOuiIAT8WJMXZpMQi5_5pFeUiTjoMqS10VLKPbdjLtp-DxT6rS-LuGS3WaNz5SIs_rFNwGSy1-5xI_MzD195-c7WVo7Joe68QK8tmUNRQGCTIFQc2rIGmI4lg0fw",
        "user_info": {
            "FirstName": "James",
            "LastName": "Miller",
            "Avatar": ""
        }
        } });
        await dispatch({ type: "GET_MY_PROFILE_DASHBOARD", payload: {
            "id": "53683fe0-69b3-494e-b9ad-2abb0cd63f4e",
            "user_name": "jamesmiller.lusid@gmail.com",
            "first_name": "James",
            "last_name": "Miller",
            "account_status": "active",
            "avatar": "",
            "primary_email": "jamesmiller.lusid@gmail.com",
            "is_primary_email_verified": true,
            "secondary_email": "",
            "is_secondary_email_verified": false,
            "primary_mobile_country_code": "1",
            "primary_mobile": "",
            "is_primary_mobile_verified": false,
            "secondary_mobile_country_code": "",
            "secondary_mobile": "",
            "is_secondary_mobile_verified": false,
            "deletedAt": null
        } });
        navigate("/dashboard");
        }, 1000);

    }
    
    // let obj = {
    //   "user_name": formData.UserName,
    //   "password": formData.Password,
    //   "region": "US"
    // };

//     setLoading(true);


    // dispatch(LogIn(obj, navigate, setLoading)).then(({res, statusCode}) => {
    //   if(statusCode === 200){
    //     if(location.state){
    //       // login from `make payment page`
    //       setTimeout(() => {
    //         navigate(location.state.redirectPath, { 
    //           replace: true,
    //           state: location.state
    //          });
    //       }, 1000);
    //     } else {
    //       // regular login
    //     }
    //   }
    //   setFormData(Data);
    // })
    
  };

  return (
    <Box >
      <Box className='auth__top'>
        <Container maxWidth="lg">
          <Box className='flexCenterSBRow'>
            <img
              src={Logo}
              alt="lusid-logo"
              style={{ width: "180px" }}
              />
            <Typography variant='h5' sx={{ color: style["secondary"] }}>
              {"Business"}
            </Typography>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Box className="auth flexCenterCenterRow" marginTop={"-40px"}>
          <Box className="auth__content flexCenterCenterRow" 
            p={"25px"}>
            <Box 
              className="flex_CenterColumn" 
              gap={"20px"} 
              width={"360px"}>
              <Typography
                variant='h6'
                textAlign={"center"}>
                Login into your account
              </Typography>
              <TextField 
                variant="outlined"
                label="Email"
                name="UserName"
                fullWidth={true}
                placeholder='Enter your email'
                value={formData.UserName}
                onChange={handleChange}
                />
              <TextField 
                variant="outlined"
                label="Password"
                name="Password"
                type={passwordShow ? "text" : "password"}
                fullWidth
                placeholder='Enter password'
                value={formData.Password}
                onChange={handleChange}
                InputProps={{
                  endAdornment: 
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setPasswordShow(!passwordShow);
                        }}>
                      {
                        passwordShow
                        ? <VisibilityOffOutlinedIcon />   
                        : <VisibilityOutlinedIcon />
                      }
                      </IconButton>
                    </InputAdornment>,
                }}
                />
              <Link
                onClick={() => navigate("/forgot-password")}>
                Forgot password?
              </Link>
              <LoadingButton
                variant='contained' 
                loading={loading}
                onClick={handleLogin}>
                Login
              </LoadingButton>
              {/* {
                !location.state
                &&
                <Button
                  variant='text'
                  onClick={() => navigate("/register")}>
                  Create new account
                </Button>
              } */}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default AuthPage;